import { Warning } from '@mui/icons-material';
import ArticleIcon from '@mui/icons-material/Article';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/Error';
import IconeRetornoVista from '@mui/icons-material/RemoveRedEye';
import SaveIcon from '@mui/icons-material/Save';
import { Chip, Stack, Tooltip } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { red } from '@mui/material/colors';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LinearProgress from '@mui/material/LinearProgress';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { action, computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';

import Configuracao from '@/util/Configuracao';
import Dominios from '@/util/Dominios';

import ReactComponent from '../ReactComponent';

class RetornoVistaRegimental extends ReactComponent {
    anchorEl = null;
    anchorElMenuItem = null;
    openMenu = Boolean(this.anchorEl);
    openEdicaoVistores = false;
    openConfirmacaoExclusao = false;
    openVisualizadorVotoVR = false;
    novosVistores = null;
    exclusaoConfirmada = false;
    executandoAcao = false;
    conteudoVotoVR = undefined;
    carregamentoConteudoFalhou = false;

    handleClickMenuRetornoVista = (event) => {
        this.anchorEl = event.currentTarget;
        this.anchorElMenuItem = this.anchorEl;
        this.openMenu = true;
    };

    handleCloseMenuRetornoVista = () => {
        this.anchorEl = null;
        this.openMenu = false;
    };

    handleCloseMenuItem = () => {
        this.openEdicaoVistores = false;
        this.openVisualizadorVotoVR = false;
        this.novosVistores = this.vistoresJulgamento;
        this.exclusaoConfirmada = false;
    };

    handleCloseConfirmacaoExclusao = () => {
        this.exclusaoConfirmada = false;
        this.openConfirmacaoExclusao = false;
    };

    handleClickConfirmacaoExclusao = async () => {
        this.exclusaoConfirmada = true;
        this.openConfirmacaoExclusao = false;
        await this.salvarVistas();
        this.handleCloseMenuItem();
    };

    abrirVisualizadorVotoVR = (sigla) => {
        this.carregarConteudoVotoVR(sigla);
        this.openMenu = false;
        this.openVisualizadorVotoVR = true;
    };

    handleCloseVisualizadorVotoVR = () => {
        this.openVisualizadorVotoVR = false;
        this.conteudoVotoVR = undefined;
    };

    abrirEdicaoVistores = () => {
        this.openMenu = false;
        this.openEdicaoVistores = true;
    };

    setNovosVistores = (event, values) => {
        if (values) {
            this.novosVistores = Array.isArray(values) ? values : [values];
        } else {
            this.novosVistores = [];
        }
    };

    handleClickGravarVistores = async () => {
        if (this.novosVistores?.length === 0) {
            this.openConfirmacaoExclusao = true;
        } else {
            await this.salvarVistas();
            this.handleCloseMenuItem();
        }
    };

    carregarConteudoVotoVR = async (sigla) => {
        this.conteudoVotoVR = undefined;
        this.carregamentoConteudoFalhou = false;

        try {
            const votoVista = await this.processoService.recuperarObservacaoVoto(
                this.registro.sessaoId,
                this.registro.processo.numeroCompleto,
                Dominios.TIPO_OBSERVACAO_VOTO_MINUTA_RETORNO_VISTA,
                sigla
            );

            if (votoVista?.[0]) {
                const conteudo = await this.processoService.recuperarConteudoObservacaoVotoPeloId(
                    this.registro.sessaoId,
                    this.registro.processo.numeroCompleto,
                    Dominios.TIPO_OBSERVACAO_VOTO_MINUTA_RETORNO_VISTA,
                    sigla,
                    votoVista[0].id
                );

                runInAction(() => {
                    this.conteudoVotoVR = conteudo.trim();
                });
            } else {
                runInAction(() => {
                    this.conteudoVotoVR = '';
                });
            }
        } catch (error) {
            runInAction(() => {
                this.carregamentoConteudoFalhou = true;
            });
            throw error;
        }
    };

    constructor(props) {
        super(props);

        makeObservable(this, {
            componentDidMount: false,
            isHabilitadaVistasSimultaneas: computed,
            labelVistores: computed,
            isMesmoMagistrado: false,
            getMagistradoUK: false,
            renderDialogConfirmacaoExclusao: false,
            renderConteudoVotoVR: false,
            renderDialogVisualizadorVotoVR: false,
            renderAlertaMagistradoSemOJ: false,
            render: false,
            anchorEl: observable,
            anchorElMenuItem: observable,
            openMenu: observable,
            openEdicaoVistores: observable,
            openConfirmacaoExclusao: observable,
            openVisualizadorVotoVR: observable,
            novosVistores: observable,
            exclusaoConfirmada: observable,
            executandoAcao: observable,
            conteudoVotoVR: observable,
            carregamentoConteudoFalhou: observable,
            idPopoverEdicaoVistores: computed,
            registro: computed,
            processo: computed,
            titularOJ: computed,
            vistas: computed,
            tooltipVistor: computed,
            labelChip: computed,
            opcoesVistores: computed,
            vistoresJulgamento: computed,
            handleClickMenuRetornoVista: action,
            handleCloseMenuRetornoVista: action,
            handleCloseMenuItem: action,
            handleCloseConfirmacaoExclusao: action,
            handleClickConfirmacaoExclusao: action,
            abrirVisualizadorVotoVR: action,
            handleCloseVisualizadorVotoVR: action,
            abrirEdicaoVistores: action,
            setNovosVistores: action,
            isDadosNovosIguaisAosAntigos: computed,
            salvarVistas: action,
            handleClickGravarVistores: action,
            carregarConteudoVotoVR: action,
            habilitarAlteracaoVista: computed
        });
    }

    componentDidMount() {
        runInAction(() => {
            this.novosVistores = this.vistoresJulgamento;
        });
    }

    get idPopoverEdicaoVistores() {
        return this.openEdicaoVistores ? 'popover-edicao-vistores' : undefined;
    }

    get registro() {
        return this.observableProps.registro;
    }

    get processo() {
        return this.registro.processo;
    }

    get titularOJ() {
        return this.processo.relator && this.processo.relator.titularOJ !== false;
    }

    get vistas() {
        return this.registro.informacoesAdicionais.RetornoVistaRegimental || [];
    }

    get tooltipVistor() {
        if (!this.vistas || this.vistas.length === 0) {
            return null;
        }

        if (this.vistas.length === 1) {
            const texto =
                'Vistor' +
                (this.vistas[0].magistrado?.genero === 'F' ? 'a' : '') +
                ': ' +
                this.vistas[0].magistrado?.nome;

            return <Typography>{texto}</Typography>;
        }

        return (
            <>
                <Typography>{this.labelVistores}:</Typography>
                <ul style={{ listStyleType: 'circle' }}>
                    {this.vistas.map((vista) => (
                        <li key={this.nextKey}>
                            <Typography>{vista.magistrado.nome ?? this.renderAlertaMagistradoSemOJ()}</Typography>
                        </li>
                    ))}
                </ul>
            </>
        );
    }

    get labelChip() {
        return this.vistas[0]?.magistrado?.sigla?.concat(this.vistas.length > 1 ? ' +' : '') ?? '';
    }

    get opcoesVistores() {
        const opcoes = [];

        for (const dadosParticipante of this.registro.composicao) {
            const { cpf, nome, sigla, genero, id } = dadosParticipante.magistrado;
            opcoes.push({ cpf, nome, sigla, genero, id });
        }

        return opcoes;
    }

    get vistoresJulgamento() {
        const vistores = [];

        if (this.vistas.length > 0) {
            for (const vista of this.vistas) {
                vistores.push(vista.magistrado);
            }
        }

        return vistores;
    }

    /**
     * Compara antes do envio para evitar que o usuário tente gravar a mesma informação que já está salva no banco de dados.
     */
    get isDadosNovosIguaisAosAntigos() {
        if (this.vistoresJulgamento.length === this.novosVistores.length) {
            let existe = 0;

            for (const vista of this.vistoresJulgamento) {
                for (const novaVista of this.novosVistores) {
                    if (this.isMesmoMagistrado(vista, novaVista)) {
                        existe++;
                    }
                }
            }

            return this.vistas.length === existe;
        }

        return false;
    }

    get isHabilitadaVistasSimultaneas() {
        return this.registro.processo.origem === Configuracao.ORIGEM_PJE;
    }

    get labelVistores() {
        if (!this.isHabilitadaVistasSimultaneas) {
            return 'Vistor';
        }

        if (this.vistas.length > 1) {
            const todasFemininas = this.vistas.every((vista) => vista.magistrado?.genero === 'F');
            return todasFemininas ? 'Vistoras' : 'Vistores';
        }

        const isFeminino = this.vistas[0]?.magistrado?.genero === 'F';
        return isFeminino ? 'Vistora' : 'Vistor';
    }

    isMesmoMagistrado(magistrado1, magistrado2) {
        return this.getMagistradoUK(magistrado1) === this.getMagistradoUK(magistrado2);
    }

    getMagistradoUK(magistrado) {
        // Verificar se é necessário validar nome e/ou CPF
        const IS_VERIFICAR_NOME = false;
        const IS_VERIFICAR_CPF = false;

        let uk = magistrado.sigla;

        if (IS_VERIFICAR_NOME && uk) {
            uk += '_'.concat(magistrado.nome.toUpperCase());
        }

        if (IS_VERIFICAR_CPF && uk) {
            uk += '_'.concat(magistrado.cpf);
        }

        return uk;
    }

    async salvarVistas() {
        let flexaoVR = 'ista regimental';

        if (this.vistoresJulgamento.length > 1) {
            flexaoVR = flexaoVR.replace('ista regimental', 'istas regimentais');
        }

        try {
            runInAction(() => {
                this.executandoAcao = true;
            });

            if (this.novosVistores && this.novosVistores.length > 0) {
                await this.sessaoService.alterarRetornoVistaRegimental(
                    this.registro.sessaoId,
                    this.registro.processo.numeroCompleto,
                    this.novosVistores
                );
                this.mensagemStore.abrirMensagemSucesso(
                    `V${flexaoVR} alterada${this.vistoresJulgamento.length > 1 ? 's' : ''} com sucesso.`
                );
            } else {
                await this.sessaoService.excluirRetornoVistaRegimental(
                    this.registro.sessaoId,
                    this.registro.processo.numeroCompleto
                );
                this.mensagemStore.abrirMensagemSucesso(
                    `V${flexaoVR} removida${this.vistoresJulgamento.length > 1 ? 's' : ''} com sucesso.`
                );
            }
            runInAction(() => {
                this.registro.informacoesAdicionais.RetornoVistaRegimental =
                    this.novosVistores && Array.isArray(this.novosVistores)
                        ? this.novosVistores.map((vistor) => {
                              return { magistrado: vistor };
                          })
                        : undefined;
            });
        } finally {
            runInAction(() => {
                this.executandoAcao = false;
            });
        }
    }

    renderDialogConfirmacaoExclusao() {
        let msgTitulo = 'Confirmação de exclusão da vista regimental';
        let msgAlerta = 'Atenção: A vista regimental será excluída. Deseja confirmar a exclusão?';

        if (this.vistoresJulgamento.length > 1) {
            msgTitulo = msgTitulo.replace('a vista regimental', 'as vistas regimentais');
            msgAlerta = msgAlerta.replace('A vista regimental será excluída', 'As vistas regimentais serão excluídas');
        }

        return (
            <Dialog
                maxWidth="xs"
                onClose={this.handleCloseConfirmacaoExclusao}
                open={this.openConfirmacaoExclusao}
            >
                <DialogTitle>
                    <Typography>{msgTitulo}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Stack direction="row">
                        <Warning sx={{ fill: 'darkorange' }} />
                        <DialogContentText
                            id="alert-dialog-description-exclusao-vista-regimental"
                            sx={{ ml: 2 }}
                        >
                            {msgAlerta}
                        </DialogContentText>
                    </Stack>
                </DialogContent>
                <DialogActions sx={{ mr: 2, mb: 1 }}>
                    <Button
                        color="secondary"
                        endIcon={<CancelIcon />}
                        onClick={this.handleCloseConfirmacaoExclusao}
                        variant="outlined"
                    >
                        Cancelar
                    </Button>
                    <Button
                        color="primary"
                        endIcon={<DeleteForeverIcon />}
                        loading={this.executandoAcao}
                        loadingPosition="end"
                        onClick={this.handleClickConfirmacaoExclusao}
                        sx={{ ml: 2 }}
                        variant="contained"
                    >
                        Remover
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    renderConteudoVotoVR() {
        if (this.conteudoVotoVR) {
            return (
                <div
                    data-sentry-mask
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{ __html: this.conteudoVotoVR }}
                />
            );
        }

        if (this.carregamentoConteudoFalhou) {
            const msgFalhaCarregamento =
                'Ocorreu uma falha ao tentar carregar a minuta. Tente novamente mais tarde ou contacte o administrador do sistema.';
            const corFalhaCarregamento = red[800];

            return (
                <Stack direction="row">
                    <ErrorIcon sx={{ fill: corFalhaCarregamento }} />
                    <DialogContentText
                        id="alert-dialog-description-falha-carregamento-vista-regimental"
                        sx={{ ml: 2, color: corFalhaCarregamento }}
                    >
                        {msgFalhaCarregamento}
                    </DialogContentText>
                </Stack>
            );
        }

        if (this.conteudoVotoVR === '') {
            const msgMinutaVazia =
                'Não foi encontrada uma minuta de retorno de vista regimental disponibilizada pelo(a) vistor(a).';
            const corMinutaVazia = 'darkorange';

            return (
                <Stack direction="row">
                    <Warning sx={{ fill: corMinutaVazia }} />
                    <DialogContentText
                        id="alert-dialog-description-vista-regimental-ausente"
                        sx={{ ml: 2, color: corMinutaVazia }}
                    >
                        {msgMinutaVazia}
                    </DialogContentText>
                </Stack>
            );
        }

        if (this.conteudoVotoVR === undefined) {
            return (
                <Box sx={{ width: '100%' }}>
                    <LinearProgress />
                </Box>
            );
        }

        return null;
    }

    renderDialogVisualizadorVotoVR() {
        return (
            <Dialog
                maxWidth="xl"
                onClose={this.handleCloseVisualizadorVotoVR}
                open={this.openVisualizadorVotoVR}
            >
                <DialogTitle>
                    <Typography>Minuta de retorno de vista regimental</Typography>
                </DialogTitle>
                <DialogContent sx={{ m: 2 }}>{this.renderConteudoVotoVR()}</DialogContent>
                <DialogActions sx={{ mr: 2, mb: 1 }}>
                    <Button
                        color="primary"
                        endIcon={<CloseIcon />}
                        onClick={this.handleCloseVisualizadorVotoVR}
                        variant="contained"
                    >
                        Fechar
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    renderAlertaMagistradoSemOJ() {
        return (
            <Tooltip
                title={
                    <Typography>
                        Atenção! Entre em contato com o administrador negocial do PJe para verificar se o magistrado
                        está associado ao OJ
                    </Typography>
                }
            >
                <Warning
                    style={{
                        fill: 'darkorange',
                        fontSize: '1.1rem',
                        verticalAlign: 'text-bottom'
                    }}
                />{' '}
                Sigla indisponível
            </Tooltip>
        );
    }

    get habilitarAlteracaoVista() {
        return this.vistas.every((vista) => vista.somenteLeitura !== true);
    }

    render() {
        if (!this.vistas || this.vistas.length === 0) {
            return null;
        }

        const menuId = 'vista-regimental-menu';

        return (
            <>
                <Box sx={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
                    <Tooltip title={this.tooltipVistor}>
                        <Chip
                            icon={
                                <IconeRetornoVista
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                        margin: this.labelChip ? '0px 0px 0px 8px' : '0px 0px 0px 16px',
                                        fillOpacity: '0.4'
                                    }}
                                />
                            }
                            style={{
                                height: '24px',
                                color: this.titularOJ ? 'black' : 'rgb(183, 28, 28)',
                                fontSize: 12
                            }}
                            aria-controls={this.openMenu ? menuId : undefined}
                            aria-expanded={this.openMenu ? 'true' : undefined}
                            aria-haspopup="true"
                            label={this.labelChip}
                            onClick={this.handleClickMenuRetornoVista}
                            size="small"
                            sx={{ ml: 2 }}
                        />
                    </Tooltip>
                </Box>
                <Menu
                    slotProps={{
                        paper: {
                            elevation: 0,
                            sx: {
                                overflow: 'visible',
                                filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
                                mt: 1.5,
                                '& .MuiChip-root': {
                                    width: 24,
                                    height: 24,
                                    ml: -0.5,
                                    mr: 1
                                },
                                '&::before': {
                                    content: '""',
                                    display: 'block',
                                    position: 'absolute',
                                    top: 0,
                                    left: 13,
                                    width: 15,
                                    height: 15,
                                    bgcolor: 'background.paper',
                                    transform: 'translateY(-50%) rotate(45deg)',
                                    zIndex: 0
                                }
                            }
                        }
                    }}
                    anchorEl={this.anchorEl}
                    anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
                    id={menuId}
                    onClick={this.handleCloseMenuRetornoVista}
                    onClose={this.handleCloseMenuRetornoVista}
                    open={this.openMenu}
                    transformOrigin={{ horizontal: 'left', vertical: 'top' }}
                >
                    {this.vistoresJulgamento.map((vistor) => {
                        return (
                            <MenuItem
                                onClick={() => {
                                    this.abrirVisualizadorVotoVR(vistor.sigla);
                                }}
                                key={this.getMagistradoUK(vistor)}
                            >
                                <ListItemIcon>
                                    <ArticleIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText>
                                    <Typography fontSize="small">
                                        Visualizar minuta de retorno de VR (
                                        {vistor.sigla ?? this.renderAlertaMagistradoSemOJ()})
                                    </Typography>
                                </ListItemText>
                            </MenuItem>
                        );
                    })}
                    {!!this.habilitarAlteracaoVista && (
                        <MenuItem onClick={this.abrirEdicaoVistores}>
                            <ListItemIcon>
                                <EditIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText>
                                <Typography fontSize="small">Alterar vistor</Typography>
                            </ListItemText>
                        </MenuItem>
                    )}
                </Menu>
                {this.openVisualizadorVotoVR ? this.renderDialogVisualizadorVotoVR() : null}
                {this.openEdicaoVistores && this.vistas.length > 0 ? (
                    <Popover
                        sx={{
                            maxWidth: '800px'
                        }}
                        anchorEl={this.anchorElMenuItem}
                        id={this.idPopoverEdicaoVistores}
                        onClose={this.handleCloseMenuItem}
                        open={this.openEdicaoVistores}
                    >
                        <Box sx={{ m: 2 }}>
                            <Autocomplete
                                filterSelectedOptions
                                defaultValue={
                                    this.isHabilitadaVistasSimultaneas
                                        ? this.vistoresJulgamento
                                        : this.vistoresJulgamento[0]
                                }
                                isOptionEqualToValue={(option, value) => {
                                    return this.isMesmoMagistrado(option, value);
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={this.labelVistores}
                                        variant="filled"
                                    />
                                )}
                                getOptionLabel={(option) => `${option.sigla} - ${option.nome}`}
                                id="selecao-vistores"
                                multiple={this.isHabilitadaVistasSimultaneas}
                                onChange={this.setNovosVistores}
                                options={this.opcoesVistores}
                            />
                            <Box sx={{ mt: 2, display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Button
                                    color="secondary"
                                    endIcon={<CancelIcon fontSize="small" />}
                                    onClick={this.handleCloseMenuItem}
                                    size="small"
                                    variant="outlined"
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    color="primary"
                                    disabled={this.isDadosNovosIguaisAosAntigos}
                                    endIcon={<SaveIcon fontSize="small" />}
                                    loading={this.executandoAcao}
                                    loadingPosition="end"
                                    onClick={this.handleClickGravarVistores}
                                    size="small"
                                    sx={{ ml: 2 }}
                                    variant="contained"
                                >
                                    Salvar
                                </Button>
                            </Box>
                        </Box>
                    </Popover>
                ) : null}
                {this.openConfirmacaoExclusao ? this.renderDialogConfirmacaoExclusao() : null}
            </>
        );
    }
}

export default inject('stores')(observer(RetornoVistaRegimental));
